// extracted by mini-css-extract-plugin
export default {"price":"qZ-z","onSale":"rZ-z","msrpLabelPrice":"sZ-z","originalPrice":"tZ-z","msrpLabel":"uZ-z","percentOff":"vZ-z"};